import { faCheck, faSpinnerThird } from '@fortawesome/pro-light-svg-icons';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { DangerouslySetHtmlContent } from 'shared/components/DangerousDiv';
import { PageContainer } from 'shared/components/PageContainer';
import { RentalPageTitleHelmet } from 'rental/components/PageTitleHelmet';
import { PageHeading } from 'shared/components/typography';
import { App_ApplicationFragment, App_PortalFragment } from '../../generated.graphql';
import { usePortalAnalytics } from '../../hooks/analytics';

interface Props {
  portal: App_PortalFragment;
  application: App_ApplicationFragment | null
}

export const SubmittingApplication = () => (
    <PageContainer>
      <RentalPageTitleHelmet>Submitting Application</RentalPageTitleHelmet>
      <div className="text-center">
        <FontAwesomeIcon icon={faSpinnerThird} spin className="text-muted" /> Submitting Application...
      </div>
    </PageContainer>
);

export const Finished = (props: Props) => {
  const { pageView, completedCheckout } = usePortalAnalytics(props.portal);

  // Use local storage to ensure we only ever execute conversion scripts once per application
  const lastApplicationId = parseInt(window.localStorage.getItem('lastApplicationId') ?? '0', 10);
  const applicationId = props.application?.id ?? props.portal.myApplication?.id ?? props.portal.myLastApplicationId ?? undefined;
  const isNewCompletedApplication = applicationId !== undefined && applicationId !== lastApplicationId;

  useEffect(() => {
    if (isNewCompletedApplication) {
      window.localStorage.setItem('lastApplicationId', applicationId?.toString() ?? '0');
      pageView();

      const application = props.application ?? props.portal.myApplication;
      if (application) {
        completedCheckout(application);
      }
    }
  }, [ isNewCompletedApplication, applicationId, pageView, completedCheckout, props.application, props.portal.myApplication ])

  return (
    <PageContainer>
      <RentalPageTitleHelmet>Submitted Successfully</RentalPageTitleHelmet>
      <PageHeading className="text-center mt-5">Thank You!</PageHeading>
      <p className="text-center my-5">Your application has been successfully submitted. We've sent you an email acknowledging its receipt and confirming the details submitted.</p>
      <p className="text-center">
        <span className="fa-stack fa-4x">
          <FontAwesomeIcon icon={faCircle} className="fa-stack-2x" color="#28a745" />
          <FontAwesomeIcon icon={faCheck} className="fa-stack-1x" inverse={true} />
        </span>
      </p>

      {isNewCompletedApplication && (
        <>
          {/* Some portals have additional conversion scripts to run */}
          <DangerouslySetHtmlContent html={props.portal.analytics.conversionScript ?? ''} />
          
          {/* Standard application conversion script */}
          {props.application && (<DangerouslySetHtmlContent html={props.application.conversionScript ?? ''} />)}
        </>
      )}
    </PageContainer>
  );
}